import { MessageDescriptor } from 'react-intl';

import { IAdditionalProductLabelMessages } from '../../model';

type Props = {
  disabled: boolean;
  maximumQuantity: number;
  itemQuantity: number;
  messages: IAdditionalProductLabelMessages;
  withDedication?: string | null;
  onClick?: () => void;
};

export const getAdditionalLabelText = ({
  disabled,
  maximumQuantity,
  itemQuantity,
  messages,
  withDedication,
  onClick,
}: Props): MessageDescriptor | null => {
  if (withDedication) {
    return messages.withDedication ?? null;
  }

  if (maximumQuantity > 0 && maximumQuantity < itemQuantity) {
    return messages.changeProductQuantity ?? null;
  }

  if (disabled) {
    return messages.removeProduct;
  }

  if (onClick) {
    return messages.viewItem ?? null;
  }

  return null;
};
